export const assetsPath = "assets/";
var imgsPath = assetsPath + "img/";
export const audioPath = assetsPath + "audio/";

export const to_load = {
    'coin_sprite'				: 'framework/assets/img/coin/coins_{q}.png',
    'win_font_bg'				: imgsPath + 'fonts/win_font_bg_{q}.png',

    "settings_background_4": imgsPath + "infos/info_winlines_{q}.png",
    "settings_background_3": imgsPath + "infos/infopage_{q}.png",
    "settings_background_2": imgsPath + "wintables/wintable2_{q}.png",
    "settings_background_1": imgsPath + "wintables/wintable1_{q}.png",
    "settings_background_1_text": imgsPath + "wintables/wintable1_{q}_text.png",
    "settings_background_2_text": imgsPath + "wintables/wintable2_{q}_text.png",
    "wintable_frame_1": imgsPath + "wintables/wintable_frame_2_{q}.png",
    "wintable_frame_2": imgsPath + "wintables/wintable_frame_1_{q}.png",
    "symbol_Devil_wink": imgsPath + 'symbols/symbol_Devil/symbol_Devil_wink_{q}.png',
    "symbol_Fire_burn": imgsPath + 'symbols/symbol_Fire/symbol_Fire_burn_{q}.png',
    'background': imgsPath + "reels/background_{q}.png",
    'reels_cover': imgsPath + "reels/reels-cover_{q}.png",
    'text_bigwin': imgsPath + 'bigwin/bigwin_text_{q}.png',
    'text_megawin': imgsPath + 'bigwin/megawin_text_{q}.png',
    'text_supermegawin': imgsPath + 'bigwin/supermegawin_text_{q}.png',
    'text_bonuswin': imgsPath + 'bigwin/bonuswin_text_{q}.png',
    'line_blue': imgsPath + 'reels/lines/line_blue_{q}.png',
    'line_green': imgsPath + 'reels/lines/line_green_{q}.png',
    'line_purple': imgsPath + 'reels/lines/line_purple_{q}.png',
    'line_red': imgsPath + 'reels/lines/line_red_{q}.png',
    'line_yellow': imgsPath + 'reels/lines/line_yellow_{q}.png',
    'lines_full': imgsPath + 'reels/lines/lines_full_{q}.png',
    'winframe_blue': imgsPath + 'reels/winframes/winframe_blue_{q}.png',
    'winframe_green': imgsPath + 'reels/winframes/winframe_green_{q}.png',
    'winframe_purple': imgsPath + 'reels/winframes/winframe_purple_{q}.png',
    'winframe_red': imgsPath + 'reels/winframes/winframe_red_{q}.png',
    'winframe_yellow': imgsPath + 'reels/winframes/winframe_yellow_{q}.png',
    'icon_Fire_Q': imgsPath + 'icon/icon_Fire_Q/icon_Fire_Q_sprite_{q}.png',
    'fire_question': imgsPath + 'icon/icon_Fire_Q/fire_question_{q}.png',
    'icon_Win': imgsPath + 'icon/icon_Win/icon_Win_sprite_{q}.png',
    'bigwin_bg': imgsPath + 'bigwin/bigwin_bg_{q}.png',
    'bigwin_shine': imgsPath + 'bigwin/bigwin_bg_shine_{q}.png',
    'bigwin_flames_1': imgsPath + 'bigwin/bigwin_flames_1_{q}.png',
    'bigwin_flames_2': imgsPath + 'bigwin/bigwin_flames_2_{q}.png',
    'bigwin_frame': imgsPath + 'bigwin/bigwin_frame_{q}.png',
    'bigwin_frame_shine': imgsPath + 'bigwin/bigwin_frame_shine_{q}.png'
};

export const to_load_json_atlas = {};

export const to_load_audio = {
    //"bet": audioPath + "bet.ogg",
    "count": audioPath + "bonus_FreeSpins_Counter.ogg",
    "fire2": audioPath + "bg_FreeSpins.ogg",
    "joker_change": audioPath + "win_Joker_Change.ogg",
    "REEL_BG": audioPath + "reel_Spin.ogg",
    "REEL_START_reels": audioPath + "reel_Start.ogg",
    "REEL_STOP": audioPath + "reel_Stop.ogg",
    "zwink": audioPath + "symbol_DevilBlink.ogg",
    "snd_win_9": audioPath + "win_9.ogg",
    "snd_win_9_yes": audioPath + "win_9_Yes.ogg",
    "snd_win_bonus": audioPath + "win_Bonus.ogg",
    "snd_win_bonus_yes": audioPath + "win_Bonus_Yes.ogg",
    "snd_win_high": audioPath + "win_High.ogg",
    "snd_win_high_yes": audioPath + "win_High_Yes.ogg",
    "snd_win_low": audioPath + "win_Low.ogg",
    "snd_win_low_yes": audioPath + "win_Low_Yes.ogg",
    "YOU_WON": audioPath + "bwin_BigWin.ogg",
    "win_x3": audioPath + "win_Multiplier.ogg",
	Jackpot_sound: assetsPath + "JokerWinBanner/Jackpot_sound.mp3",
	JokerBonus_alert: assetsPath + "JokerWinBanner/JokerBonus_alert.mp3",
};

export const to_load_json = {
    'infotext' 				: assetsPath + "info/info_{l}.json"
};

export const to_load_fonts = {
    'win_font' :	{
        "img":	imgsPath + 'fonts/win_font.png',
        "xml":	imgsPath + 'fonts/win_font.xml'
    },

    'bigwin_fonts': {
        'img': imgsPath + 'fonts/bigwin_fonts.png',
        'xml': imgsPath + 'fonts/bigwin_fonts.xml'
    },
    'fs_font_yellow': {
        'img': imgsPath + 'fonts/font_freespins_1.png',
        'xml': imgsPath + 'fonts/font_freespins_1.xml'
    },
    'fs_font_white': {
        'img': imgsPath + 'fonts/font_freespins_2.png',
        'xml': imgsPath + 'fonts/font_freespins_2.xml'
    },
    'font_wintable': {
        'img': imgsPath + 'fonts/font_wintable.png',
        'xml': imgsPath + 'fonts/font_wintable.xml'
    }
};

export const post_load_audio_win_symbols = {
    "win_symbol_Scatter_4"	: audioPath + "win_Clown_4x.ogg",
    "win_symbol_Scatter_5"	: audioPath + "win_Clown_5x.ogg",
    "win_symbol_Devil_4"	: audioPath + "win_Devil_4x.ogg",
    "win_symbol_Devil_5"	: audioPath + "win_Devil_5x.ogg",
    "win_symbol_Knight_4"	: audioPath + "win_Knight_4x.ogg",
    "win_symbol_Knight_5"	: audioPath + "win_Knight_5x.ogg",
    "win_symbol_King_4"		: audioPath + "win_King_4x.ogg",
    "win_symbol_King_5"		: audioPath + "win_King_5x.ogg",
    "win_symbol_Nix_4"		: audioPath + "win_Nix_4x.ogg",
    "win_symbol_Nix_5"		: audioPath + "win_Nix_5x.ogg",
    "win_symbol_Princess_4"	: audioPath + "win_Princess_4x.ogg",
    "win_symbol_Princess_5"	: audioPath + "win_Princess_5x.ogg",
    "win_symbol_Queen_4"	: audioPath + "win_Queen_4x.ogg",
    "win_symbol_Queen_5"	: audioPath + "win_Queen_5x.ogg",
    "win_symbol_Mystery_4"	: audioPath + "win_Witch_4x.ogg",
    "win_symbol_Mystery_5"	: audioPath + "win_Witch_5x.ogg",
    "win_symbol_Wild_4"		: audioPath + "win_Wild_4x.ogg",
    "win_symbol_Wild_5"		: audioPath + "win_Wild_5x.ogg",
};

export const post_load_json_atlas_standing = {
    'symbol_Devil_standing_json': [imgsPath + "symbols/symbol_Devil/symbol_Devil_stand_atlas_{q}.png", imgsPath + "symbols/symbol_Devil/symbol_Devil_stand_atlas_{q}.json"],
    'symbol_King_standing_json': [imgsPath + "symbols/symbol_King/symbol_King_stand_atlas_{q}.png", imgsPath + "symbols/symbol_King/symbol_King_stand_atlas_{q}.json"],
    'symbol_Knight_standing_json': [imgsPath + "symbols/symbol_Knight/symbol_Knight_stand_atlas_{q}.png", imgsPath + "symbols/symbol_Knight/symbol_Knight_stand_atlas_{q}.json"],
    'symbol_Mystery_standing_json': [imgsPath + "symbols/symbol_Mystery/symbol_Witch_stand_atlas_{q}.png", imgsPath + "symbols/symbol_Mystery/symbol_Witch_stand_atlas_{q}.json"],
    'symbol_Nix_standing_json': [imgsPath + "symbols/symbol_Nix/symbol_Nix_stand_atlas_{q}.png", imgsPath + "symbols/symbol_Nix/symbol_Nix_stand_atlas_{q}.json"],
    'symbol_Princess_standing_json': [imgsPath + "symbols/symbol_Princess/symbol_Princess_stand_atlas_{q}.png", imgsPath + "symbols/symbol_Princess/symbol_Princess_stand_atlas_{q}.json"],
    'symbol_Queen_standing_json': [imgsPath + "symbols/symbol_Queen/symbol_Queen_stand_atlas_{q}.png", imgsPath + "symbols/symbol_Queen/symbol_Queen_stand_atlas_{q}.json"],
    'symbol_Scatter_standing_json': [imgsPath + "symbols/symbol_Scatter/symbol_Clown_stand_atlas_{q}.png", imgsPath + "symbols/symbol_Scatter/symbol_Clown_stand_atlas_{q}.json"],
    'symbol_Wild_standing_json': [imgsPath + "symbols/symbol_Wild/symbol_Wild_stand_atlas_{q}.png", imgsPath + "symbols/symbol_Wild/symbol_Wild_stand_atlas_{q}.json"]
};

import { madnes_set_audio_volume } from "../../framework/src/engine/madnes/madnes_audio";

export function set_sounds(server_config) {

    var vol = server_config['volume']['bigWin'];
    if (typeof vol !== "undefined") {
        madnes_set_audio_volume('YOU_WON', vol);
    }

    vol = server_config['volume']['buttonEffect'];
    if (typeof vol !== "undefined") {
        madnes_set_audio_volume('button_click', vol);
    }

    vol = server_config["volume"]["spin"];
    if (typeof vol !== "undefined") {
        madnes_set_audio_volume('REEL_BG', vol);
    }

    vol = server_config['volume']['startReel'];
    if (typeof vol != "undefined")
    {
        madnes_set_audio_volume('REEL_START_reels', vol);
    }

    vol = server_config['volume']['stopReel'];
    if (typeof server_config.volume.stopReel != "undefined")
    {
        madnes_set_audio_volume('REEL_STOP', vol);
    }

    if (typeof server_config["volume"]["winAnim"] != "undefined")
    {
        vol = server_config["volume"]["winAnim"];
        madnes_set_audio_volume('win_x3', vol);
        madnes_set_audio_volume('joker_change', vol);

        madnes_set_audio_volume('snd_win_9', vol);
        madnes_set_audio_volume('snd_win_9_yes', vol);
        madnes_set_audio_volume('snd_win_bonus', vol);
        madnes_set_audio_volume('snd_win_bonus_yes', vol);
        madnes_set_audio_volume('snd_win_high', vol);
        madnes_set_audio_volume('snd_win_high_yes', vol);
        madnes_set_audio_volume('snd_win_low', vol);
        madnes_set_audio_volume('snd_win_low_yes', vol);
    }

    if (typeof server_config.volume.winCounter != "undefined")
    {
        madnes_set_audio_volume('remittance_A', server_config.volume.winCounter);
        madnes_set_audio_volume('remittance_B', server_config.volume.winCounter);
        madnes_set_audio_volume('count', server_config.volume.winCounter);
    }

    if (typeof server_config["background"]["freeSpinsBackground"] !== "undefined") {
        vol = server_config["background"]["freeSpinsBackground"];
        madnes_set_audio_volume('fire2', vol);
    }

    if (typeof server_config.miscSounds.miscSounds1 != "undefined")
    {
        madnes_set_audio_volume('coins_loop', server_config.miscSounds.miscSounds1);
    }

    if (typeof server_config.miscSounds.miscSounds2 != "undefined")
    {
        madnes_set_audio_volume('zwink', server_config.miscSounds.miscSounds2);
    }

}